import React from "react";
import "./cta.css";

const CTA = () => (
  <div className="tuh__cta">
    <div className="tuh__cta-content">
      <p>Minta Akses Awal untuk Memulai</p>
      <h3>Daftar Hari Ini & Mulai Eksplorasi Wawasan Baru</h3>
    </div>
    <div className="tuh__cta-btn">
      <button type="button">Ayo Mulai</button>
    </div>
  </div>
);

export default CTA;
